module.exports = __webpack_public_path__ + "img/espionage-agency.41fbbcdb.jpg";